<template>
  <div class="studentBind location">


 <van-form @submit="onSubmit" style="margin:20px 0;height: 100vh;" class="dialogBox">
        <div v-show="+step == 1">
<section class="section">
        <van-field readonly v-model="formData.schoolName"  label="学校" placeholder="请搜索选择学校（如：南京）" :rules="[{ required: true }]" @click="schoolShowPicker = true;" />
</section>

<footer class="footer van-safe-area-bottom">
      <div class="buutom">
          <CustomButton  text="关闭" @click="showDialog=false" type='2'/>
          <CustomButton  text="下一步"  @click="nextStep(1)" type='1'/>
      </div>
</footer>
     
        </div>
        <div v-show="+step == 2">
      
        <!-- <van-field v-model="formData.adminTeacherName" type="text" name="班主任姓氏" label="班主任姓氏" placeholder="请输入班主任姓氏"
          :rules="[{ required: true }]" />
          
        <van-field v-model="formData.adminTeacherSex" type="text" name="班主任性别" label="班主任性别" placeholder="请输入班主任性别"
          :rules="[{ required: true }]" > -->
    <!-- <template #input>
       <van-radio-group v-model="formData.adminTeacherSex" direction="horizontal">
        <van-radio name="男">男</van-radio>
        <van-radio name="女">女</van-radio>
      </van-radio-group>
    </template>
  </van-field> -->
        <!-- <van-field v-model="formData.sportTeacherName" type="text" name="体育老师姓氏" label="体育老师姓氏" placeholder="请输入体育老师姓氏"
          :rules="[{ required: true }]" />
        <van-field v-model="formData.sportTeacherSex" type="text" name="体育老师性别" label="体育老师性别" placeholder="请输入体育老师性别"
          :rules="[{ required: true }]" >
    <template #input>
       <van-radio-group v-model="formData.sportTeacherSex" direction="horizontal">
        <van-radio name="男">男</van-radio>
        <van-radio name="女">女</van-radio>
      </van-radio-group>
    </template>
  </van-field> -->
        <div class="buutom">
          <CustomButton  text="上一步" @click="upStep(2)" type='2'/>
          <CustomButton  text="下一步"  @click="nextStep(2)" type='1'/>
        </div>
        </div>
        <div v-show="+step == 3">
         <van-field v-model="formData.studentName" type="text" name="姓名" label="姓名" placeholder="请输入姓名"
          :rules="[{ required: true }]" />
            <van-field v-model="formData.idNumber" type="text" name="身份证号" label="身份证号" placeholder="请输入身份证号"
          :rules="[{ required: true }]" />
        <!-- <van-field v-model="formData.inSchooleYear"  type="number" :maxlength='4' name="入学年份" label="入学年份" placeholder="请输入入学年份"
          :rules="[{ required: true }]" /> -->
     <div class="buutom">
          <CustomButton  text="上一步" @click="upStep(3)" type='2'/>
          <CustomButton  text="确认" native-type="submit" type='1'/>
        </div>
        </div>

   
    

 

  <!-- <div class="buutom">
    <CustomButton  text="返回" @click="showDialog=false" type='2'/>
    <CustomButton  text="确认" native-type="submit" type='1'/>
  </div> -->
      </van-form>







   <van-popup v-model="schoolShowPicker" round position="bottom" :style="{ height: '55%' }">
      <van-search v-model="searchvalue" placeholder="请输入学校名称关键字搜索（如：南京）" />
      <van-picker :columns="schoolColumns" :default-index="defaultIndex" show-toolbar @cancel="schoolShowPicker = false"
        @confirm="onConfirmSchool" />
    </van-popup>
    <!-- <van-button round block type="info" class="button-add" @click="addStudent">+  绑定孩子</van-button> -->


  </div>
</template>

<script>
import { Notify } from "vant";
import CustomButton from "@/components/CustomButton.vue";

import { getSchoolList} from "@/api/common";
import { getChildInfoList,bindStudentInfo} from "@/api/studentBind.js";
    import wx from 'weixin-js-sdk'
import { loginByOpenId} from "@/api/bind"
import { setLocal, getLocal } from '@/utils/cookie'

import studentCard from "@/components/studentCard.vue";
export default {
  name: "studentBind",
  components: {CustomButton,studentCard},
  data() {
    return {
      step:1,
      snCode: "",
      studentName: "",
      openId: "",
      formData:{
        schoolName:'',
        adminTeacherName:'',
        sportTeacherName:'',
        adminTeacherSex:'男',
        sportTeacherSex:'男'
      },
      active:'0',
      showDialog:false,
      schoolShowPicker:false,
      searchvalue:'',
      schoolColumns:[],
      columnsAll:[],
      defaultIndex:'',
      studentList:[],
      statusMap:['待审核','通过','已驳回']
    };
  },
   watch: {
    searchvalue(val) {
      if (!val || !val.trim()) {
        this.schoolColumns = [];
        return;
      }
      this.getSchoolList(val.trim());
    },
  },
  created() {
  
  },
  mounted () {
    this.schoolColumns = [];
    this.getChildInfoList();
  },
  methods: {

nextStep(val){
if (val == 1&&this.formData.schoolName=='') {
  this.$notify({ type: "warning", message: '请填写全部信息！' });
  return
}else if (val==2) {

  if (this.formData.adminTeacherName==''||this.formData.adminTeacherSex==''||
  this.formData.sportTeacherName==''||this.formData.sportTeacherSex=='') {
  this.$notify({ type: "warning", message: '请填写全部信息！' });
    return
  }
}
this.step = val + 1

},
upStep(val){
this.step = val -1
},
    getChildInfoList(){
getChildInfoList({
  status:'-1'
}).then(res=>{
  this.studentList = res.data.data||[]
  this.studentList?.forEach(el=>{
    if (el.sex=='男') {
      this.$set(el,'sexImg',require("@/assets/image/男.png") )
    }else if(el.sex=='女'){
      this.$set(el,'sexImg',require("@/assets/image/女.png") )
    }
  })
console.log(res);
})
    },
    getSchoolList(keyword) {
      if (!keyword || !keyword.trim()) {
        this.schoolColumns = [];
        return;
      }
      getSchoolList({ keyword: keyword.trim() }).then((res) => {
        const body = res?.data?.body || res?.data?.data || res?.data || [];
        if (Array.isArray(body)) {
          this.schoolColumns = body.map((item) => {
            return { text: item.name || item.schName || '', value: item.code || item.schCode || '' };
          }).filter(i => i.text && i.value);
        } else {
          this.schoolColumns = [];
        }
      }).catch(err => {
        console.warn("获取学校失败", err);
        this.schoolColumns = [];
      });
    },
    addStudent(){
        loginByOpenId({openId:getLocal('openId')}).then(res=>{
              console.log(res);
              setLocal("userInfo", JSON.stringify(res.data.body));
              setLocal("Authorization", res.data.body.token);

      this.formData = {
          schoolName:'',
        adminTeacherName:'',
        sportTeacherName:'',
        adminTeacherSex:'男',
        sportTeacherSex:'男',
      }
      this.showDialog = true
              })



    },
    onSubmit(){
console.log(this.formData);
let data = {...this.formData}
//  await loginByOpenId({openId:getLocal('openId')}).then(res=>{
//               console.log(res);
//               setLocal("userInfo", JSON.stringify(res.data.body));
//               setLocal("Authorization", res.data.body.token);


//                bindStudentInfo(data).then(res=>{
//     this.$notify({ type: "success", message: '绑定成功' });
//     this.getChildInfoList()
//     this.getChildInfoBySnCode()  
// })

//               })

bindStudentInfo(data).then(res=>{
    this.$notify({ type: "success", message: '绑定成功' });
    this.getChildInfoList()
    this.formData = {
      adminTeacherSex:'男',
      sportTeacherSex:'男'
    }
    this.showDialog = false;
  // wx.closeWindow()
})
    },
    // 选择学校
       onConfirmSchool(val) {
        this.formData.schoolName = val.text;
        this.formData.schoolCode = val.value;
        this.schoolShowPicker = false;
    },
    onRemove(){
        this.$dialog
        .alert({
          message: '是否确认解除绑定?',
          showCancelButton: true
        })
        .then(() => {
           
        })
        .catch(() => {
          // on cancel
        })
    },

  },
};
</script>


<style scoped lang="less">

.studentBind{
  display: flex;
  flex-direction: column;
  overflow-y: auto;

 
  .section{
    flex: 1;
    overflow: scroll;
  }
  .footer{
    display: flex;
    margin-bottom: 6%;
    margin-top: 5%;
    justify-content: space-around;
  }
  }
.dialogBox{
  max-height: 100vh;
  overflow: scroll;
}
.studentCard{
  background-color: #fff;
  border-radius: 10px;
  margin: 8px;
  padding: 15px;
   box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
  .studentCard_title{
    display: flex;
    justify-content: space-between;
    font-size: 25px;
    font-weight: 600;
  }
  .studentCard_value{
    color: #ccc;
  }
}
.buutom {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  .button-on{
    width: 48%;
}
}
  .button-add{
    width: 80%;
    margin: 0 auto;
    margin-top: 50px;
}

</style>
